import React from 'react';
import { Clock, Tag, MessageSquare } from 'lucide-react';
import { formatTime } from '../../utils/formatters';

const MessageBubble = ({ message }) => {
  const getMessageClass = () => {
    if (message.type === 'event') return 'message-bubble event';
    if (message.type === 'log') return 'message-bubble log';
    if (message.user === 'You') return 'message-bubble sent';
    return 'message-bubble received';
  };

  const getIcon = () => {
    if (message.type === 'event') return <Tag className="message-icon" />;
    if (message.type === 'log') return <MessageSquare className="message-icon" />;
    return null;
  };

  return (
    <div className={`message-wrapper ${message.user === 'You' ? 'sent' : 'received'}`}>
      <div className={getMessageClass()}>
        {message.type !== 'message' && (
          <div className="message-type-header">
            {getIcon()}
            <span className="message-type-label">{message.type.toUpperCase()}</span>
          </div>
        )}
        <p className="message-text">{message.text}</p>
        <div className="message-time">
          <Clock className="time-icon" />
          <span>{formatTime(message.timestamp)}</span>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;